import React, { useCallback } from 'react'
import { connect } from 'react-redux'
import { FaSignOutAlt } from 'react-icons/fa'
import { BsArrowRight, BsArrowLeft } from 'react-icons/bs'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import './navlinks.css'
import logAppEvent from '../../Api/appEventsLogging'

const NavLinks = ({ user }) => {
  const navigate = useNavigate()
  const location = useLocation()

  const logoutHandler = useCallback(() => {
    localStorage.removeItem('token')
    navigate('/')
  }, [navigate])

  const handleTabClick = useCallback(
    (tabName) => {
      const eventName = location.pathname.includes('/transcripts-summaries')
        ? 'transcripts_ask_arrowhead_tab_click'
        : 'ask_ask_arrowhead_tab_click'

      logAppEvent(`${eventName}`, {
        user_id: user?.id,
      })
    },
    [location]
  )

  const handleBackClick = () => {
    logAppEvent('transcripts_back_tab_click', {
      user_id: user?.id,
    })
  }

  return (
    <div className='nav_links'>
      <button className='logout-button' onClick={logoutHandler}>
        <FaSignOutAlt size={20} />
      </button>
      <h2>
        {location.pathname.includes('/transcripts-summaries/summary') ||
        location.pathname.includes('/transcripts-summaries/transcript') ||
        location.pathname.includes('/transcripts-summaries/dashboard') ||
        location.pathname.includes('/transcripts-summaries/first_event') ? (
            <Link
              to='/transcripts-summaries'
              className={
                location.pathname.includes('/transcripts-summaries')
                  ? 'active_link back'
                  : 'back'
              }
              onClick={handleBackClick}
            >
              <BsArrowLeft size={16} />
            Back
            </Link>
          ) : user?.name ? (
            `Hi, ${user?.name?.trim().split(' ')[0]}`
          ) : (
            'Hi'
          )}
      </h2>
      {!location.pathname.includes('/transcripts-summaries/') && (
        <>
          <Link
            to='/ask?tab=new'
            className={location.pathname === '/ask' ? 'active_link' : ''}
          >
            <BsArrowRight size={16} />
            Ask Arrowhead
          </Link>
          <Link
            to='/transcripts-summaries'
            className={
              location.pathname.includes('/transcripts-summaries')
                ? 'active_link'
                : ''
            }
          >
            <BsArrowRight size={16} />
            Your meetings
          </Link>
          {/* <Link
        to="/tasks"
        className={location.pathname === "/tasks" ? "active_link" : ""}
      >
        <BsArrowRight size={16} />
        Tasks
      </Link> */}
        </>
      )}
    </div>
  )
}

const mapStateToProps = (state) => ({
  user: state.user.data,
})

export default connect(mapStateToProps, null)(NavLinks)
